<div *ngIf="transactions" class="basket-main">
  <div class="basket-main-header">
    <div class="row">
      <div class="col-6 col-sm-3">
        {{ 'Date, Time' | translate }}
      </div>
      <div class="col-6 col-sm-5">
        {{ 'Order' | translate }}
      </div>
      <div class="col-6 col-sm-2">
        {{ 'Type' | translate }}
      </div>
      <div class="col-6 col-sm-2">
        {{ 'Amount' | translate }}
      </div>
    </div>
  </div>
  <div [ngClass]="translationTableClass">
    <div *ngFor="let transaction of transactions">
      <div class="row">
        <div class="col-6 col-sm-3">
          <span>{{ formatDateTime(transaction.transactionTime) }}</span>
        </div>
        <div class="col-6 col-sm-5">
          <span>{{transaction.orderRef || ''}}</span>
        </div>
        <div class="col-6 col-sm-2">
          <span>{{transaction.type | translate}}</span>
        </div>
        <div class="col-6 col-sm-2">
          <span>{{formatMoneyText(transaction.amount)}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
